var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_383",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29035",
    "data-name": "Group 29035",
    transform: "translate(-4043 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4043, -4899)",
    filter: "url(#Ellipse_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383-2",
    "data-name": "Ellipse 383",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-slack-new",
    transform: "translate(4059 -4886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50718",
    "data-name": "Path 50718",
    d: "M31.894,7.447a3.447,3.447,0,1,0-6.894,0v9.479a3.447,3.447,0,0,0,6.894,0Z",
    transform: "translate(-2.903)",
    fill: "#33d375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50719",
    "data-name": "Path 50719",
    d: "M41.894,18.447a3.447,3.447,0,0,1-3.447,3.447H35V18.447a3.447,3.447,0,1,1,6.894,0Z",
    transform: "translate(-4.286 -1.521)",
    fill: "#33d375"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50720",
    "data-name": "Path 50720",
    d: "M7.447,14a3.447,3.447,0,1,0,0,6.894h9.479a3.447,3.447,0,0,0,0-6.894Z",
    transform: "translate(0 -1.383)",
    fill: "#40c4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50721",
    "data-name": "Path 50721",
    d: "M18.447,4a3.447,3.447,0,0,1,3.447,3.447v3.447H18.447a3.447,3.447,0,1,1,0-6.894Z",
    transform: "translate(-1.521)",
    fill: "#40c4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50722",
    "data-name": "Path 50722",
    d: "M14,36.935a3.447,3.447,0,0,0,6.894,0V27.47a3.447,3.447,0,0,0-6.894,0Z",
    transform: "translate(-1.383 -2.769)",
    fill: "#e91e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50723",
    "data-name": "Path 50723",
    d: "M4,27.47a3.444,3.444,0,0,1,3.447-3.442h3.447V27.47A3.447,3.447,0,0,1,4,27.47Z",
    transform: "translate(0 -2.769)",
    fill: "#e91e63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50724",
    "data-name": "Path 50724",
    d: "M36.926,31.894a3.447,3.447,0,0,0,0-6.894H27.447a3.447,3.447,0,1,0,0,6.894Z",
    transform: "translate(-2.765 -2.903)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50725",
    "data-name": "Path 50725",
    d: "M27.447,41.894A3.447,3.447,0,0,1,24,38.447V35h3.447a3.447,3.447,0,0,1,0,6.894Z",
    transform: "translate(-2.765 -4.286)",
    fill: "#ffc107"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.b626437cc1c04158906fdea92ec359a7.svg";
export { ForwardRef as ReactComponent };